import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { TooltipComponent } from '@atoms/tooltip/tooltip.component';

@Injectable({
  providedIn: 'root',
})
export class TooltipService {
  private componentRef?: ComponentRef<TooltipComponent>;
  private componentSubscriber?: Subject<string>;
  private entry?: ViewContainerRef;

  setEntry(entry: ViewContainerRef): void {
    this.entry = entry;
  }

  open(content: string, element: HTMLElement, position: 'top' | 'bottom', zIndex: 'default' | 'max'): Observable<string> | undefined {
    if (!this.entry) return;
    this.componentRef = this.entry.createComponent(TooltipComponent);
    this.componentRef.instance.content = content;
    this.componentRef.instance.element = element;
    this.componentRef.instance.position = position;
    this.componentRef.instance.zIndex = zIndex;
    this.componentRef.instance.initPosition();
    this.componentSubscriber = new Subject<string>();
    return this.componentSubscriber.asObservable();
  }

  close(): void {
    if (!this.componentRef) return;
    this.componentRef.destroy();
    this.componentSubscriber?.complete();
  }
}
